import React from "react";
import { Field, ErrorMessage, FieldProps } from "formik";

type Props = {
    name: string;
    label?: string;
    type?: "text" | "number" | "email" | "tel";
    placeholder?: string;
    inputClassName?: string;
    onChange: (value: React.FormEvent<HTMLInputElement>) => void;
    onBlur?: () => void;
    onFocus?: () => void;
    disableAutocomplete?: boolean;
};

// Formik form field component with a label and error message.
export const ManagedFormikField: React.FC<Props> = (props: Props) => {
    return (
        <>
            {props.label ? (
                <label htmlFor={props.name} className={"col-form-label"}>
                    {props.label}
                </label>
            ) : null}

            <Field name={props.name}>
                {(fieldProps: FieldProps<string>) => (
                    <input
                        autoComplete={props.disableAutocomplete ? "off" : ""}
                        type={props.type}
                        className={`form-control form-control-lg ${props.inputClassName ?? ""}`}
                        placeholder={props.placeholder}
                        {...fieldProps.field}
                        onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                            fieldProps.field.onBlur(e);
                            props.onBlur?.();
                        }}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            fieldProps.field.onChange(e);
                            props.onChange(e);
                        }}
                        onFocus={props?.onFocus}
                    />
                )}
            </Field>
            <ErrorMessage name={props.name} component="div" className="error-msg" />
        </>
    );
};
